








































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header/main-header.vue";
import ReportFengmian from "../components/report-fengmian.vue";
import ReportShe from "../components/report-she.vue";
import ReportMian from "../components/report-mian.vue";
import ReportJingluo from "../components/report-jingluo.vue";
import ReportTizhi from "../components/report-tizhi.vue";
import ReportStatus from "../components/report-status.vue";
import ReportFangan from "../components/report-fangan.vue";
import ReportChild6 from "../components/report-child6.vue";
import ReportChild12 from "../components/report-child12.vue";
import ReportGaoxueya from "../components/report-gaoxueya.vue";
import ReportTangniaobing from "../components/report-tangniaobing.vue";

import { getFanganList } from "@/request/manage";
@Component({
  components: {
    MainHeader,
    ReportFengmian,
    ReportShe,
    ReportMian,
    ReportJingluo,
    ReportTizhi,
    ReportStatus,
    ReportFangan,
    ReportChild6,
    ReportChild12,
    ReportGaoxueya,
    ReportTangniaobing
  },
})
export default class Name extends Vue {
  private patient: any = {};
  private data: any = [];
  private cpart: any = {};
  private ifEdit: any = false;
  private ifShowYangsheng: any = false;
  private ifShowGanyu: any = false;
  private save() {
    this.ifEdit = false;
  }
  private delFangan(i: any) {
    if (this.data[this.data.length - 1].fangans.length == 1) {
      this.data.splice(this.data.length - 1, 1);
    } else {
      this.data[this.data.length - 1].fangans.splice(i, 1);
    }
  }
  /**
   * @description 切换左边导航
   */
  private changePart(item: any) {
    const parant: any = document.getElementById("printReport");
    const children: any = document.getElementById(item.id);
    if (parant) {
      if (children) {
        const parentTop = parant.offsetTop;
        const childTop = children.offsetTop;
        parant.scrollTop = childTop - parentTop - 14;
      }
    }
    setTimeout(() => {
      this.cpart = item;
    }, 50);
  }
  private scrollEvent() {
    const parant = document.getElementById("printReport");
    if (parant) {
      const scrollTop = parant.scrollTop;
      const parentTop = parant.offsetTop + 14;
      this.data.forEach((ele: any, i: any) => {
        if (i < this.data.length - 1) {
          const cuEle = document.getElementById(ele.id);
          const nextEle = document.getElementById(this.data[i + 1]?.id);
          if (cuEle && nextEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            const nextTop = nextEle.offsetTop - parentTop;
            if (scrollTop >= cuTop && scrollTop < nextTop) {
              this.cpart = ele;
            }
          }
        } else {
          const cuEle = document.getElementById(ele.id);
          if (cuEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            if (scrollTop >= cuTop) {
              this.cpart = ele;
            }
          }
        }
      });
    }
  }
  private getData() {
    this.data.unshift({
      id: "fengmian",
      报告名称: "封面",
    });
    if (this.ifShowYangsheng) {
      this.data.push({
        id: "yangsheng",
        报告名称: "养生方案",
        fangans: [],
      });
    }
    if (this.ifShowGanyu) {
      this.data.push({
        id: "ganyu",
        报告名称: "干预方案",
        fangans: [],
      });
    }

    this.changePart(this.data[0]);
    if (this.ifShowYangsheng || this.ifShowGanyu) {
      this.data.forEach((ele: any) => {
        if (this.ifShowYangsheng) {
          const index: any = this.data.findIndex((val: any) => {
            return val["报告名称"] == "养生方案";
          });
          if (ele["养生方案"] && ele["养生方案"].length > 0) {
            ele["养生方案"].forEach((e: any) => {
              const params = {
                params: {
                  project_name: e.title,
                  ceping_name: ele["报告名称"],
                },
              };
              getFanganList(this, params).then((res: any) => {
                if (res.data.length > 0) {
                  res.data.forEach((d: any) => {
                    const obj = d;
                    d.origin = e;
                    d.origin["报告名称"] = ele["报告名称"];
                    this.data[index].fangans.push(obj);
                  });
                }
              });
            });
          }
        }
        if (this.ifShowGanyu) {
          const index: any = this.data.findIndex((val: any) => {
            return val["报告名称"] == "干预方案";
          });
          if (ele["干预方案"] && ele["干预方案"].length > 0) {
            ele["干预方案"].forEach((e: any) => {
              const params = {
                params: {
                  project_name: e.title,
                  ceping_name: ele["报告名称"],
                },
              };
              getFanganList(this, params).then((res: any) => {
                if (res.data.length > 0) {
                  res.data.forEach((d: any) => {
                    const obj = d;
                    d.origin = e;
                    d.origin["报告名称"] = ele["报告名称"];
                    this.data[index].fangans.push(obj);
                  });
                }
              });
            });
          }
        }
      });
    }
  }
  private mounted() {
    if (this.$route.query.ifShowYangsheng) {
      this.ifShowYangsheng =
        this.$route.query.ifShowYangsheng == "是" ? true : false;
    }
    if (this.$route.query.ifShowGanyu) {
      this.ifShowGanyu = this.$route.query.ifShowGanyu == "是" ? true : false;
    }
    if (this.$route.query.patient) {
      this.patient = JSON.parse(this.$route.query.patient as any);
    }
    if (this.$route.query.data) {
      this.data = JSON.parse(this.$route.query.data as any);
      const arr = [
        {
          "chd_id": "ddede30db7ad480a83fa8d0872fbff2c",
          "doctor_id": "doctor_id_12766",
          "hospital_id": "hospital_id_301",
          "id": "ddede30db7ad480a83fa8d0872fbff2c",
          "patient_id": "480645",
          "体质得分": {
            "data": [
              "0.111",
              "0.049",
              "0.234",
              "0.118",
              "0.055",
              "0.047",
              "0.059",
              "0.297"
            ],
            "title": [
              "气虚体",
              "阳虚体",
              "痰湿体",
              "积滞体",
              "肝火体",
              "热盛体",
              "高敏体",
              "怯弱体"
            ]
          },
          "体质类型": "健康体",
          "养生方案": [
            {
              "title": "健康体_两岁及以上",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/6/健康体_两岁及以上.pdf"
            }
          ],
          "常见表现与易发疾病": "健康体儿童主要表现为体态适中、面色红润、精力充沛、脏腑功能强健等特征。",
          "干预方案": [],
          "报告名称": "0-6岁儿童体质辨识",
          "方案建议": [
            {
              "name": "健康体_两岁及以上",
              "path": "https://oss.tcm-ai.com/programe/6/健康体_两岁及以上.pdf",
              "type": "file"
            }
          ],
          "来源设备ID": "12766",
          "检测日期": "2022-03-31",
          "检测时间": "2022-03-31 14:53:52",
          "评估结果": "健康体",
          "采集时间": "2022-03-31 14:53:52"
        }, {
          "chd_id": "fcc8160e8936418cb374e424c01ca628",
          "doctor_id": "doctor_id_12766",
          "hospital_id": "hospital_id_301",
          "id": "fcc8160e8936418cb374e424c01ca628",
          "patient_id": "491894",
          "体质得分": {
            "data": [
              "0.29",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0"
            ],
            "title": [
              "平人质",
              "阳热质",
              "阴虚质",
              "阳虚质",
              "痰湿质",
              "气滞质",
              "气虚质",
              "肺气虚质",
              "脾气虚质",
              "肾气虚质"
            ]
          },
          "体质类型": "平人质",
          "养生方案": [
            {
              "title": "自定义方案",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/doctor_id_12766/6/20220422_c652a6c9e1a949e7963357acffbf852b.pdf"
            }
          ],
          "常见表现与易发疾病": "面色红润有光泽，皮肤润泽有弹性，舌形正常、舌色淡红、舌苔薄白，体力充沛，大小便情况正常、睡眠良好、饮食正常、精神比较饱满、性格活泼开朗、有一定的学习与社交能力等。",
          "干预方案": [],
          "报告名称": "7-12岁儿童体质辨识",
          "来源设备ID": "12766",
          "检测日期": "2022-04-22",
          "检测时间": "2022-04-22 13:37:41",
          "评估结果": "根据本次的测试结果，您孩子的体质具有平人质的体质特征。平人质是儿童机体功能良好，阴阳相对均衡、气血调和的一种体质类型。",
          "采集时间": "2022-04-22 13:37:41"
        },
        {
          "doctor_id": "doctor_id_14477",
          "hospital_id": "hospital_id_979",
          "hyp_id": "275e002efa8b44e8886d4e65c8172285",
          "id": "275e002efa8b44e8886d4e65c8172285",
          "patient_id": "480161",
          "主诉": "下肢浮肿; 小便频数; 夜尿多",
          "养生方案": [
            {
              "title": "心肾气虚_养生方案_简版1",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/5/心肾气虚_养生方案_简版1.pdf"
            }
          ],
          "医生建议": "",
          "干预方案": [
            {
              "title": "心肾气虚_干预方案_简版",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/5/心肾气虚_干预方案_简版.pdf"
            }
          ],
          "报告名称": "高血压辅助辨证",
          "来源设备ID": "14477",
          "检测日期": "2022-03-30",
          "检测时间": "2022-03-30 15:39:28",
          "症状": "失眠;健忘;爪甲淡白;口渴;渴喜热饮;痰多",
          "舌脉症状": "齿痕舌;舌裂;舌苔黄;苔腻",
          "辨证分型": "心肾气虚",
          "采集时间": "2022-03-30 15:39:28"
        }, {
          "dia_id": "7591cdde0a49451199aa6b869e5aa5c6",
          "doctor_id": "doctor_id_14477",
          "hospital_id": "hospital_id_979",
          "id": "7591cdde0a49451199aa6b869e5aa5c6",
          "patient_id": "480161",
          "养生方案": [
            {
              "title": "肾气虚_春季方案",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/11/肾气虚_春季方案.pdf"
            }
          ],
          "医生建议": "",
          "干预方案": [
            {
              "title": "肾气虚_干预方案",
              "url": "https://gyhl.oss-cn-shanghai.aliyuncs.com/programe/11/肾气虚_干预方案.pdf"
            }
          ],
          "报告名称": "糖尿病辅助辨证",
          "来源设备ID": "14477",
          "检测日期": "2022-03-30",
          "检测时间": "2022-03-30 15:41:23",
          "症状": "",
          "舌脉症状": "尚未进行客观化信息采集",
          "舌面脉客观化信息": "",
          "辨证分型": "肾气虚",
          "采集时间": "2022-03-30 15:41:23"
        }
      ]
      // this.data= this.data.concat(arr)

      this.getData();
    }
  }
}
